export enum AnalyticsDataPeriodEnum {
    LAST_WEEK = 'last_week',
    LAST_MONTH = 'last_month',
    LAST_TRIMESTER = 'last_trimester',
    LAST_YEAR = 'last_year'
}
